export default {
  auth: () => import("/usr/src/app/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/usr/src/app/layouts/default.vue").then(m => m.default || m),
  "knowledge-base": () => import("/usr/src/app/layouts/knowledge-base.vue").then(m => m.default || m),
  public: () => import("/usr/src/app/layouts/public.vue").then(m => m.default || m)
}